



































import { Component, Vue } from 'vue-property-decorator';
import { VoucherItem } from '@/types/voucher';
import Voucher from '@/components/voucher/voucher.vue';
import { getCardCache, getCVBarConfig } from '@/business/voucher';
import PayComp from '@/hk-cv-base/components/common/pay-comp.vue';
import Item from '../../components/voucher/info-cell.vue';
import { windowHelper, biHottag } from '@tencent/ppd-base-libs';
import { biHT } from '@/business/bi';
import { QrpayFromScene } from '@tencent/wphk-components-jump-page';

/** 政府消费券叠券后的通用ID */
const GOV_CV_COMBINED = 'GOV_CV_COMBINED';
/** 政府消费券类型ID */
const GOV_CV_TYPE = '4001';

// import { i18n } from '@/i18n';
@Component({
  components: {
    Voucher,
    PayComp,
    Item,
  },
})
export default class VoucherList extends Vue {
  /** 消费券券数据 */
  private voucher: VoucherItem & {isInValid: boolean} = getCardCache();

  private get userConfig() {
    if (!this.voucher) {
      return [];
    }
    return getCVBarConfig(this.voucher);
  }

  /**
   * 消费券ID
   * 政府消费券使用叠券后的通用ID
   */
  private get userCvId() {
    if (!this.voucher) {
      return '';
    }
    return this.voucher.cvType === GOV_CV_TYPE ? GOV_CV_COMBINED : this.voucher.userCvId;
  }

  /**
   * 拉起刷卡场景，好生活公众号
   */
  private get qrpayScene() {
    return QrpayFromScene.HKLife;
  }

  private async created() {
    if (!this.voucher) {
      return this.$router.push({
        name: 'voucherlist',
      });
    }
    // 这里可能消费跳转到原生刷卡后进行了支付，回来的时候需要刷新消费券金额信息
    document.addEventListener('visibilitychange', this.onPageVisiblilityChange);
    biHT('wallet.cvlist.detailpage.brow', {
      fcvid: this.voucher.cvId,
    });
  }

  private beforeDestroy() {
    document.removeEventListener(
      'visibilitychange',
      this.onPageVisiblilityChange,
    );
  }

  private onPageVisiblilityChange() {
    if (!document.hidden) {
      // 这里一定要刷新整个页面，否则wx config会覆盖掉页面初始化时最初的配置，导致拉起原生刷卡失败
      location.reload();
    }
  }

  private clickItem(item) {
    if (item.clickStat) biHottag(item.clickStat, {
      fcvid: this.voucher.cvId,
    });
    if (item.link) {
      windowHelper.redirect(item.link, 300);
    }
  }
  private clickPayCode() {
    biHT('wallet.cvlist.detailpage.pay_click', {
      fcvid: this.voucher.cvId,
    });
  }
  private clickScanCode() {
    biHT('wallet.cvlist.detailpage.scan_click', {
      fcvid: this.voucher.cvId,
    });
  }
}
